import {Form, InputNumber, Radio, Switch, Tooltip, Typography} from 'antd';
import {InfoCircleOutlined, DollarOutlined} from '@ant-design/icons';

const {Text} = Typography;

const CURRENCIES = [
  {value: 'EGP', flag: '🇪🇬'},
  {value: 'USD', flag: '🇺🇸'},
  {value: 'AED', flag: '🇦🇪'},
  {value: 'SAR', flag: '🇸🇦'},
  {value: 'QAR', flag: '🇶🇦'},
  {value: 'KWD', flag: '🇰🇼'},
  {value: 'TRY', flag: '🇹🇷'},
];

interface CurrencyPriceSectionProps {
  showCustomPrice: boolean;
  onToggleCustomPrice: (val: boolean) => void;
}

export const CurrencyPriceSection = ({
  showCustomPrice,
  onToggleCustomPrice,
}: CurrencyPriceSectionProps) => {
  return (
    <div>
      {/* Currency Toggle Buttons */}
      <Form.Item
        name="currency"
        label="Currency"
        initialValue="EGP"
        rules={[{required: true, message: 'Select a currency'}]}>
        <Radio.Group buttonStyle="solid" size="middle">
          {CURRENCIES.map(c => (
            <Radio.Button key={c.value} value={c.value}>
              {c.flag} {c.value}
            </Radio.Button>
          ))}
        </Radio.Group>
      </Form.Item>

      {/* Custom Price Toggle */}
      <Form.Item
        label={
          <span>
            Custom Price&nbsp;
            <Tooltip title="Leave OFF to auto-calculate price from the selected package based on currency. Turn ON to override with a custom amount.">
              <InfoCircleOutlined style={{color: '#aaa'}} />
            </Tooltip>
          </span>
        }>
        <Switch
          checked={showCustomPrice}
          onChange={onToggleCustomPrice}
          checkedChildren="Custom ON"
          unCheckedChildren="Auto Price"
        />
      </Form.Item>

      {/* Animated Custom Price Input */}
      <div
        style={
          {
            maxHeight: showCustomPrice ? '120px' : '0px',
            overflow: 'hidden',
            transition: 'max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
            opacity: showCustomPrice ? 1 : 0,
            transition2: 'opacity 0.3s ease',
          } as any
        }>
        {showCustomPrice && (
          <Form.Item
            name="finalPrice"
            rules={[
              {required: showCustomPrice, message: 'Please enter a price'},
              {type: 'number', min: 0, message: 'Price must be 0 or more'},
            ]}>
            <InputNumber
              style={{width: '100%'}}
              placeholder="Enter custom price..."
              min={0}
              prefix={<DollarOutlined />}
              size="large"
            />
          </Form.Item>
        )}
      </div>

      {!showCustomPrice && (
        <Text
          type="secondary"
          style={{fontSize: 12, display: 'block', marginTop: -8}}>
          💡 Price will be auto-calculated from the package based on selected
          currency
        </Text>
      )}
    </div>
  );
};
